module.exports = __webpack_public_path__ + "img/example3.2f1ec18.png";